<div class="asc-search">
  <ng-container *ngIf="isCollapseBtn">
    <button nz-button class="flex items-center justify-center" [nzTooltipTitle]="isCollapse ? 'Mở rộng' : 'Đóng'" nz-tooltip (click)="toggleCollapseEvent($event)">
      <i nz-icon nzType="filter" nzTheme="outline"></i>
    </button>
  </ng-container>
  <ng-container *ngIf="isClearBtn">
    <button nz-button class="flex items-center justify-center" (click)="clearEvent($event)" nzTooltipTitle="Xóa tìm kiếm"
    nzTooltipPlacement="bottom" nz-tooltip>
    <i nz-icon nzType="clear" nzTheme="outline"></i>
  </button>
  </ng-container>
  <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
    <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="searchEvent($event)">Tìm kiếm</button>
  </ng-container>
  <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
    <button nz-button class="flex items-center justify-center" style="width: 100px;" [nzType]="'primary'" 
      nzTooltipTitle="Tìm kiếm" 
      nzTooltipPlacement="bottom" 
      nz-tooltip (click)="searchEvent($event)"><i nz-icon nzType="search" nzTheme="outline"></i></button>
  </ng-container>
  <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
    <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="searchEvent($event)"><i nz-icon nzType="search" nzTheme="outline"></i>Tìm kiếm</button>
  </ng-container>
</div>